/* ============
 * Bootstrap File
 * ============
 *
 * Will configure and bootstrap the application.
 */


/* ============
* Vue
* ============
*
* Vue.js is a library for building interactive web interfaces.
* It provides data-reactive components with a simple and flexible API.
*
* http://rc.vuejs.org/guide/
*/
import('vuetify/dist/vuetify.min.css');
import Vue from 'vue';
import FBSignInButton from 'vue-facebook-signin-button';
import Vuetify from 'vuetify';
import VeeValidate from 'vee-validate';
import VueHead from 'vue-head';
import jQuery from 'jquery';
import VueCarousel from 'vue-carousel';
import VueHighcharts from 'vue-highcharts';
import VueScrollTo from 'vue-scrollto';
import VueClipboard from 'vue-clipboard2';
import * as VueGoogleMaps from 'vue2-google-maps';
import SocialSharing from 'vue-social-sharing';

Vue.use(SocialSharing);
Vue.config.debug = process.env.NODE_ENV !== 'production';
Vue.use(FBSignInButton);
Vue.use(Vuetify);
Vue.use(VeeValidate, {
  events: 'input',
});
Vue.use(VueHead);
Vue.use(VueCarousel);
Vue.use(VueHighcharts);
Vue.use(VueScrollTo);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAoU9dsy6d4DPec27dIlZK-3yDq-QWOHJA',
    libraries: 'places',
    loadGoogleApi: false,
  },
});
Vue.use(VueClipboard);
window.$ = window.jQuery = jQuery;



// WEBPACK FOOTER //
// ./src/plugins/bootstrap.js